(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sic-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sic-delivery-estimate')) return;
    const eu = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));
    const transitByCountry = { GB: [4, 6], US: [5, 7], CA: [6, 10], AU: [10, 15], NZ: [10, 15], CH: [7, 10], NO: [7, 10] };
    const storageKey = 'sicDeliveryCountry';
    const dayFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', timeZone: 'UTC' });
    const monthFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
    const yearFormat = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    const atelierFormat = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'Europe/Sofia' });
    const today = () => {
      const parts = atelierFormat.formatToParts(new Date());
      const value = type => Number(parts.find(part => part.type === type).value);
      return new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    };
    const addProductionDays = (date, count) => {
      const result = new Date(date);
      while (count > 0) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) count -= 1;
      }
      return result;
    };
    const addTransitDays = (date, count) => {
      const result = new Date(date);
      result.setUTCDate(result.getUTCDate() + count);
      return result;
    };
    let countryDiscovery;
    const discoverCountry = () => {
      if (!countryDiscovery) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        countryDiscovery = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(4000) : undefined })
          .then(response => response.ok ? response.json() : null)
          .then(data => data && data.detected_values && data.detected_values.country ? data.detected_values.country.handle : null)
          .catch(() => null);
      }
      return countryDiscovery;
    };
    class SicDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          this.update();
          this.timer = setInterval(() => this.update(), 60000);
          return;
        }
        this.ready = true;
        const codes = JSON.parse(this.dataset.countryCodes || '[]');
        const names = JSON.parse(this.dataset.countryNames || '[]');
        this.countries = codes.map((code, index) => ({ code, name: (names[index] || code).replace(/&amp;/g, '&') })).filter(country => country.code !== 'IN');
        this.select = this.querySelector('[data-delivery-select]');
        this.change = this.querySelector('[data-delivery-change]');
        this.picker = this.querySelector('[data-delivery-picker]');
        this.countries.sort((a, b) => a.name.localeCompare(b.name, 'en'));
        this.select.replaceChildren(...this.countries.map(country => new Option(country.name, country.code)));
        let saved = null;
        try { saved = sessionStorage.getItem(storageKey); } catch (error) {}
        this.userSelected = this.countries.some(country => country.code === saved);
        this.country = this.userSelected ? saved : this.dataset.initialCountry;
        this.fallback = this.querySelector('[data-delivery-dates]').textContent;
        this.change.hidden = this.countries.length < 2;
        this.change.addEventListener('click', () => {
          this.picker.hidden = !this.picker.hidden;
          this.change.setAttribute('aria-expanded', String(!this.picker.hidden));
          if (!this.picker.hidden) this.select.focus();
        });
        this.select.addEventListener('change', () => {
          this.country = this.select.value;
          this.userSelected = true;
          try { sessionStorage.setItem(storageKey, this.country); } catch (error) {}
          this.update();
          this.picker.hidden = true;
          this.change.setAttribute('aria-expanded', 'false');
          this.change.focus();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.picker.hidden) {
            this.picker.hidden = true;
            this.change.setAttribute('aria-expanded', 'false');
            this.change.focus();
          }
        });
        this.update();
        if (!this.userSelected) {
          discoverCountry().then(code => {
            if (this.userSelected || !this.isConnected) return;
            if (this.countries.some(country => country.code === code)) {
              this.country = code;
              this.update();
            }
          });
        }
        this.timer = setInterval(() => this.update(), 60000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      update() {
        const country = this.countries.find(item => item.code === this.country);
        if (!country) {
          this.querySelector('[data-delivery-dates]').textContent = this.fallback;
          return;
        }
        const range = eu.has(country.code) ? [3, 5] : (transitByCountry[country.code] || [14, 25]);
        const orderDay = today();
        const from = addTransitDays(addProductionDays(orderDay, 5), range[0]);
        const to = addTransitDays(addProductionDays(orderDay, 7), range[1]);
        const sameYear = from.getUTCFullYear() === to.getUTCFullYear();
        const sameMonth = sameYear && from.getUTCMonth() === to.getUTCMonth();
        const fromText = sameMonth ? dayFormat.format(from) : (sameYear ? monthFormat.format(from) : yearFormat.format(from));
        const toText = sameYear ? monthFormat.format(to) : yearFormat.format(to);
        const result = fromText + '–' + toText;
        const dates = this.querySelector('[data-delivery-dates]');
        if (dates.textContent !== result) dates.textContent = result;
        this.querySelector('[data-delivery-country]').textContent = country.name;
        this.select.value = country.code;
      }
    }
    customElements.define('sic-delivery-estimate', SicDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sic-welcome-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.SICWelcome) return;
  var configNode = document.getElementById('SICWelcomeConfig');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var words = config.words || {};
  var rootUrl = (config.root || '/').replace(/\/?$/, '/');
  var storageKey = 'sic_welcome_v1';
  var maxAge = 24 * 60 * 60 * 1000;
  var state = { email: '', requested: false, extra: false, updatedAt: 0 };
  var cartState = config.cart || null;
  var pending = 0;
  var tail = Promise.resolve();
  var navigating = false;
  var bound = new WeakSet();
  var watchedPrices = new WeakSet();
  var customer = config.customer || {};
  var returning = Boolean(customer.signedIn && Number(customer.orders) > 0);

  function normal(value) { return String(value || '').trim().toLowerCase(); }
  function sameCode(a, b) { return normal(a) === normal(b); }
  function personalFirstCode(code) { return /^FIRST25/i.test(String(code || '')); }
  function personalReturningCode(code) { return /^RETURN25/i.test(String(code || '')); }
  function legacyExtraOpen() { return !config.legacyExtraEndsAt || Date.now() < Date.parse(config.legacyExtraEndsAt); }
  function ownCode(code) { return sameCode(code, config.code) || sameCode(code, config.extraCode); }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function safeEmail(value) { return String(value || '').trim().slice(0, 254); }

  try {
    var saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
    if (saved && typeof saved.email === 'string' && Date.now() - saved.updatedAt < maxAge) {
      state.email = safeEmail(saved.email);
      state.requested = saved.requested === true;
      state.extra = saved.extra === true && legacyExtraOpen();
      state.updatedAt = saved.updatedAt;
    }
  } catch (_) {}
  try {
    var urlCodes = new URL(window.location.href).searchParams.get('discount') || '';
    if (legacyExtraOpen() && urlCodes.split(',').some(function (code) { return sameCode(code, 'EXTRA5'); })) state.extra = true;
  } catch (_) {}
  if (customer.signedIn) {
    if (returning || (state.email && normal(state.email) !== normal(customer.email))) {
      state.requested = false;
      state.extra = false;
    }
    state.email = safeEmail(customer.email);
  }
  var emailDraft = state.email;
  var editingEmail = false;

  function saveState() {
    state.updatedAt = Date.now();
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
  }

  function codes(cart) {
    var values = [];
    (cart && cart.discount_codes || []).forEach(function (entry) {
      if (entry && entry.code) values.push(String(entry.code));
    });
    (cart && cart.cart_level_discount_applications || []).forEach(function (entry) {
      if (entry.type === 'discount_code' && entry.title) values.push(String(entry.title));
    });
    return values.filter(function (value, index) {
      return values.findIndex(function (other) { return sameCode(value, other); }) === index;
    });
  }

  function allocatedCode(cart, predicate) {
    return (cart && cart.discount_codes || []).some(function (entry) {
      return entry.applicable === true && predicate(entry.code);
    }) || (cart && cart.cart_level_discount_applications || []).some(function (entry) {
      return Number(entry.total_allocated_amount || 0) > 0 && predicate(entry.title);
    });
  }

  function extraOffer(cart) {
    if (allocatedCode(cart, personalFirstCode)) return true;
    return legacyExtraOpen() && (state.extra || allocatedCode(cart, function (code) {
      return sameCode(code, 'EXTRA5') || sameCode(code, config.extraCode);
    }));
  }

  function applied(cart) {
    if (!cart || !(cart.total_discount > 0)) return false;
    var own = (cart.discount_codes || []).some(function (entry) {
      return (ownCode(entry.code) || personalFirstCode(entry.code)) && entry.applicable === true;
    });
    return own || (cart.cart_level_discount_applications || []).some(function (entry) {
      return entry.total_allocated_amount > 0 &&
        (ownCode(entry.title) || personalFirstCode(entry.title) || normal(entry.title) === normal(config.automaticTitle));
    });
  }

  function eligibleSubtotal(cart) {
    if (!cart) return 0;
    if (!Array.isArray(cart.items)) return Number(cart.eligible_subtotal || cart.items_subtotal_price || 0);
    return cart.items.reduce(function (sum, item) {
      return sum + (item.gift_card ? 0 : Number(item.final_line_price || 0));
    }, 0);
  }

  function discounted(cents, rate) {
    var value = Math.max(0, Math.round(Number(cents) || 0));
    return value - Math.round(value * rate);
  }

  function betterSaving(cart) {
    return Boolean(cart && cart.item_count > 0 && eligibleSubtotal(cart) > 0 &&
      Number(cart.total_discount || 0) >= Math.round(eligibleSubtotal(cart) * (extraOffer(cart) ? 0.25 : 0.20)));
  }

  function money(cents, currency) {
    var locale = document.documentElement.lang || config.locale || 'en';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: currency || config.currency || 'EUR',
        currencyDisplay: 'symbol'
      }).format((Number(cents) || 0) / 100);
    } catch (_) { return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + (currency || 'EUR'); }
  }

  function checkoutUrl(email) {
    var path = (config.cartUrl || rootUrl + 'cart').replace(/\/$/, '') + '/checkout';
    var url = new URL(path, window.location.origin);
    if (email) url.searchParams.set('checkout[email]', safeEmail(email));
    return url.pathname + url.search;
  }

  function checkoutTargets() {
    return Array.from(document.querySelectorAll('[data-sic-checkout], .cart-drawer__checkout'));
  }

  function syncBusy() {
    document.querySelectorAll('[data-sic-welcome-apply]').forEach(function (button) {
      button.disabled = pending > 0 || returning;
      text(button, pending > 0 ? words.adding : words.apply);
    });
    document.querySelectorAll('[data-sic-welcome-email]').forEach(function (input) { input.readOnly = pending > 0; });
    checkoutTargets().forEach(function (node) {
      node.setAttribute('aria-busy', pending > 0 ? 'true' : 'false');
      node.setAttribute('aria-disabled', pending > 0 ? 'true' : 'false');
      if (node.tagName === 'BUTTON') node.disabled = pending > 0;
      if (node.tagName === 'A') node.href = checkoutUrl(state.email);
    });
  }

  function withCartMutation(operation) {
    pending += 1;
    syncBusy();
    var job = tail.then(operation);
    tail = job.catch(function () {});
    return job.finally(function () { pending -= 1; syncBusy(); });
  }

  async function request(path, payload) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 15000);
    try {
      var options = {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json' }
      };
      if (payload) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }
      var response = await window.fetch(rootUrl + path, options);
      var data = await response.json();
      if (!response.ok || !data || typeof data.item_count !== 'number') throw new Error('Cart request failed');
      return data;
    } finally { window.clearTimeout(timer); }
  }

  async function ensureCartDiscount(cart, force, email) {
    var existing = codes(cart);
    if (returning) {
      var retained = existing.filter(function (code) { return !ownCode(code); });
      if (retained.length !== existing.length) return request('cart/update.js', { discount: retained.join(',') });
      return cart;
    }
    if (!force && !state.requested) return cart;
    var personal = existing.some(function (code) { return personalFirstCode(code) || personalReturningCode(code); });
    if (personal && applied(cart)) return cart;
    var extra = !personal && extraOffer(cart);
    var desired = extra ? config.extraCode : config.code;
    var retainedCodes = existing.filter(function (code) { return !ownCode(code); });
    if (extra && legacyExtraOpen() && !retainedCodes.some(function (code) { return sameCode(code, 'EXTRA5'); })) retainedCodes.push('EXTRA5');
    var already = existing.some(function (code) { return sameCode(code, desired); });
    if (!force && already && !existing.some(function (code) { return ownCode(code) && !sameCode(code, desired); })) return cart;
    if (!force && applied(cart) && !extra) return cart;
    retainedCodes.push(desired);
    var payload = { discount: retainedCodes.join(',') };
    if (email) payload.attributes = { sic_welcome_email__: email };
    return request('cart/update.js', payload);
  }

  function friendlyTitle(value) {
    if (sameCode(value, config.extraCode)) return words.saving_extra;
    if (sameCode(value, config.code) || normal(value) === normal(config.automaticTitle)) return words.saving;
    return value || words.discount;
  }

  function makeLine(parent, label, amount, emphasis) {
    var labelNode = document.createElement('p');
    labelNode.className = 'cart-subtotal-label';
    text(labelNode, label);
    var valueNode = document.createElement('p');
    valueNode.className = 'cart-subtotal-value';
    if (emphasis) {
      labelNode.classList.add('sic-cart-total-label');
      valueNode.classList.add('sic-cart-total-value');
    }
    text(valueNode, amount);
    parent.appendChild(labelNode);
    parent.appendChild(valueNode);
  }

  function renderTotals(cart) {
    var totals = document.querySelector('[data-sic-cart-totals]');
    if (!totals || !cart) return;
    var note = totals.querySelector('.cart-subtotal-note');
    var noteCopy = note ? note.cloneNode(true) : null;
    totals.replaceChildren();
    makeLine(totals, words.subtotal, money(cart.items_subtotal_price, cart.currency));
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      if (discount.total_allocated_amount > 0) {
        makeLine(totals, friendlyTitle(discount.title), '−' + money(discount.total_allocated_amount, cart.currency));
      }
    });
    makeLine(totals, words.total, money(cart.total_price, cart.currency), true);
    if (noteCopy) totals.appendChild(noteCopy);
  }

  function selectedProductPrice(node) {
    var initial = Number(node.dataset.basePrice || 0);
    var json = document.querySelector('[data-product-json]');
    if (!json) return initial;
    try {
      var product = JSON.parse(json.textContent);
      var current = document.querySelector('[data-variant-id]');
      var urlVariant = new URL(window.location.href).searchParams.get('variant');
      var id = current && current.value || urlVariant;
      var variant = (product.variants || []).find(function (item) { return String(item.id) === String(id); });
      if (variant) return Number(variant.price || initial);
    } catch (_) {}
    return initial;
  }

  function renderRoot(node, cart) {
    var isCart = node.dataset.context === 'cart';
    var cartExists = Boolean(cart && cart.item_count > 0);
    var active = applied(cart);
    var better = betterSaving(cart) && !active;
    var ready = state.requested && !cartExists;
    var collapsed = (active && state.email || better || ready) && !editingEmail;
    node.hidden = returning || codes(cart).some(personalReturningCode) || (isCart && (!cartExists || eligibleSubtotal(cart) <= 0));
    var isExtra = extraOffer(cart);
    text(node.querySelector('[data-sic-welcome-title]'), isExtra ? words.title_extra : words.title);
    var rate = isExtra ? 0.25 : 0.20;
    var base = isCart ? eligibleSubtotal(cart) : selectedProductPrice(node);
    var firstPrice;
    var saving;
    if (isCart && (active || better)) {
      firstPrice = cart.total_price;
      saving = Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    } else if (isCart) {
      saving = Math.round(base * rate);
      firstPrice = Math.max(0, Number(cart.items_subtotal_price || base) - saving);
    } else {
      firstPrice = discounted(base, rate);
      saving = Math.max(0, base - firstPrice);
    }
    var currency = cart && cart.currency || config.currency;
    text(node.querySelector('[data-sic-welcome-price-label]'), isCart ? (better ? words.bag_total : words.first_total) : words.first_price);
    text(node.querySelector('[data-sic-welcome-price]'), money(firstPrice, currency));
    text(node.querySelector('[data-sic-welcome-saving]'), words.you_save.replace('__SIC_AMOUNT__', money(saving, currency)));
    var fields = node.querySelector('[data-sic-welcome-fields]');
    if (fields) fields.hidden = collapsed;
    var input = node.querySelector('[data-sic-welcome-email]');
    if (input && document.activeElement !== input && input.value !== emailDraft) input.value = emailDraft;
    var success = node.querySelector('[data-sic-welcome-success]');
    if (success) {
      success.hidden = !collapsed;
      text(success.querySelector('[data-sic-welcome-success-text]'),
        better ? words.better : (ready ? words.ready : words.added));
    }
    var changeEmail = node.querySelector('[data-sic-welcome-edit]');
    if (changeEmail) changeEmail.hidden = customer.signedIn || !state.email;
    text(node.querySelector('[data-sic-welcome-intro]'), words.intro);
    syncBusy();
  }

  function renderRoots(cart) {
    document.querySelectorAll('[data-sic-welcome]').forEach(function (node) { renderRoot(node, cart); });
  }

  function announce(cart) {
    cartState = cart;
    hydrate(document);
    renderTotals(cart);
    document.querySelectorAll('[data-sic-checkout-total]').forEach(function (node) {
      text(node, money(cart.total_price, cart.currency));
    });
    renderRoots(cart);
    document.dispatchEvent(new CustomEvent('sic:welcome-cart-updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function showError(node, message) {
    var errorNode = node.querySelector('[data-sic-welcome-error]');
    if (errorNode) { text(errorNode, message); errorNode.hidden = !message; }
  }

  async function apply(node) {
    var input = node.querySelector('[data-sic-welcome-email]');
    if (!input || pending) return;
    input.value = safeEmail(input.value);
    if (!input.value || !input.checkValidity()) {
      input.setAttribute('aria-invalid', 'true');
      showError(node, words.email_error);
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    showError(node, '');
    var email = input.value;
    try {
      await withCartMutation(async function () {
        var cart = await request('cart.js');
        cart = await ensureCartDiscount(cart, true, email);
        if (cart.item_count > 0 && !applied(cart) && !betterSaving(cart)) throw new Error('Discount not applied');
        state.email = email;
        emailDraft = email;
        editingEmail = false;
        state.requested = true;
        state.extra = legacyExtraOpen() && !codes(cart).some(personalFirstCode) && extraOffer(cart);
        saveState();
        announce(cart);
        var live = document.getElementById('sr-status');
        text(live, cart.item_count > 0 ? words.added + ' ' + words.total + ': ' + money(cart.total_price, cart.currency) : words.ready);
      });
    } catch (_) {
      showError(node, words.error);
    }
  }

  function bind(node) {
    if (bound.has(node)) return;
    bound.add(node);
    var button = node.querySelector('[data-sic-welcome-apply]');
    var input = node.querySelector('[data-sic-welcome-email]');
    var edit = node.querySelector('[data-sic-welcome-edit]');
    if (button) button.addEventListener('click', function () { apply(node); });
    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') { event.preventDefault(); apply(node); }
      });
      input.addEventListener('input', function () {
        emailDraft = input.value;
        input.removeAttribute('aria-invalid');
        showError(node, '');
      });
    }
    if (edit) edit.addEventListener('click', function () {
      editingEmail = true;
      renderRoot(node, cartState);
      if (input) { input.focus(); input.select(); }
    });
    if (node.dataset.context === 'product') {
      var regularPrice = document.querySelector('[data-product-price]');
      if (regularPrice && !watchedPrices.has(regularPrice)) {
        watchedPrices.add(regularPrice);
        new MutationObserver(function () { renderRoots(cartState); })
          .observe(regularPrice, { subtree: true, childList: true, characterData: true });
      }
    }
  }

  function hydrate(scope) {
    var nodes = scope.matches && scope.matches('[data-sic-welcome]') ? [scope] :
      Array.from(scope.querySelectorAll('[data-sic-welcome]'));
    nodes.forEach(function (node) { bind(node); renderRoot(node, cartState); });
    syncBusy();
  }

  async function goToCheckout(form) {
    if (navigating) return;
    navigating = true;
    try {
      await withCartMutation(async function () {
        var cart;
        if (form) {
          form = document.getElementById('cart-form') || form;
          var quantities = Array.from(form.querySelectorAll('[data-qty-input]')).map(function (input) {
            return Math.max(0, Number.parseInt(input.value, 10) || 0);
          });
          var payload = { updates: quantities };
          var note = form.querySelector('[name="note"]');
          if (note) payload.note = note.value;
          cart = await request('cart/update.js', payload);
        } else cart = await request('cart.js');
        cart = await ensureCartDiscount(cart, false, state.email);
        announce(cart);
        if (!cart.item_count) throw new Error('Empty cart');
        var checkoutCodes = codes(cart).filter(function (code) { return !ownCode(code); });
        if (checkoutCodes.length !== codes(cart).length) {
          await request('cart/update.js', { discount: checkoutCodes.join(',') });
        }
        window.location.assign(checkoutUrl(state.email));
      });
    } catch (_) {
      navigating = false;
      text(document.getElementById('sr-status'), words.error);
      document.querySelectorAll('[data-sic-welcome]').forEach(function (node) { showError(node, words.error); });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-sic-checkout], a.cart-drawer__checkout');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!state.email && !state.requested && !pending) return;
    event.preventDefault();
    goToCheckout();
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('#cart-form') || !event.submitter || event.submitter.name !== 'checkout') return;
    if (!state.email && !state.requested && !pending) return;
    event.preventDefault();
    goToCheckout(form);
  }, true);
  document.addEventListener('shopify:section:load', function (event) { hydrate(event.target); });
  ['variant:change', 'variant:changed', 'product:variant-change', 'change'].forEach(function (name) {
    document.addEventListener(name, function () {
      window.requestAnimationFrame(function () { renderRoots(cartState); });
    });
  });

  window.SICWelcome = {
    withCartMutation: withCartMutation,
    ensureCartDiscount: ensureCartDiscount,
    request: request,
    announce: announce,
    hydrate: hydrate,
    checkoutUrl: function () { return checkoutUrl(state.email); },
    friendlyTitle: friendlyTitle,
    goToCheckout: goToCheckout,
    isBusy: function () { return pending > 0; }
  };

  function start() {
    hydrate(document);
    if (state.requested || returning) {
      withCartMutation(async function () {
        var cart = await request('cart.js');
        cart = await ensureCartDiscount(cart, false, state.email);
        announce(cart);
      }).catch(function () {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
